import TypedNativeModules from "../internal/TypedNativeModules";

export type BridgeImplementations<K extends keyof typeof TypedNativeModules> = {
  [P in K]: Promise<(typeof TypedNativeModules)[P]>;
};

export function awaitBridges<K extends keyof typeof TypedNativeModules>(
  bridges: readonly K[],
): BridgeImplementations<K> {
  const initializers: Array<[K, Promise<(typeof TypedNativeModules)[K]>]> = bridges.map(
    (bridgeName) => [bridgeName, Promise.resolve(TypedNativeModules[bridgeName])],
  );

  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- RN-5783 baseline: pre-existing cast; migrate to zod/proper types (see docs/type-assertions.md)
  return Object.fromEntries(initializers) as BridgeImplementations<K>;
}
